import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("um_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getProducts = () => api.get("/products").then((r) => r.data);
export const getBundle = () => api.get("/products/bundle").then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const captureLead = (email) => api.post("/leads", { email }).then((r) => r.data);
export const validateDiscount = (code) => api.post("/discount/validate", { code }).then((r) => r.data);
export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const createCheckout = (payload) => api.post("/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (id) => api.get(`/payments/status/${id}`).then((r) => r.data);

export const adminLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
